import React from "react";

const TermsServices = () => {
  return (
    <div className="settings-terms flex justify-center">
      <p className="underline font-semibold text-center">
        Read our{" "}
        <a
          href="https://mathdingo.com/terms_and_conditions.html"
          className="text-gray-700"
          target="_blank"
          rel="noreferrer"
        >
          Terms
        </a>{" "}
        and{" "}
        <a
          href="https://mathdingo.com/privacy_policy.html"
          className="text-gray-700"
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
      </p>
    </div>
  );
};

export default TermsServices;
